import { expensesListingStore } from '@/app/features/expenses/features/expenses-listing/expenses-listing.store';
import { expenseDetailsStore } from '@/app/features/expenses/features/expense-details/expense-details.store';

export const expensesStore = {
  modules: {
    expensesListingState: expensesListingStore,
    expenseDetailsState: expenseDetailsStore
  }
};
